// extracted by mini-css-extract-plugin
module.exports = {"billing-summary":"billing-summary-1cofNKa","address":"address-3W2xJIc"};